"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./src/owl-carousel.component');
var ɵngcc2 = require('./src/owl-child.component');
var ɵngcc3 = require('@angular/common');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var owl_carousel_component_1 = require('./src/owl-carousel.component');
var owl_child_component_1 = require('./src/owl-child.component');
require('owl.carousel');
__export(require('./src/owl-carousel.component'));
var OwlModule = (function () {
    function OwlModule() {
    }
    OwlModule = __decorate([ __metadata('design:paramtypes', [])
    ], OwlModule);
OwlModule.ɵfac = function OwlModule_Factory(t) { return new (t || OwlModule)(); };
OwlModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OwlModule });
OwlModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            common_1.CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwlModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [
                    common_1.CommonModule
                ],
                declarations: [
                    owl_carousel_component_1.OwlCarousel, owl_child_component_1.OwlChild
                ],
                exports: [
                    owl_carousel_component_1.OwlCarousel,
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OwlModule, { declarations: [ɵngcc1.OwlCarousel, ɵngcc2.OwlChild], imports: [ɵngcc3.CommonModule], exports: [ɵngcc1.OwlCarousel] }); })();
    return OwlModule;
}());
exports.OwlModule = OwlModule;

//# sourceMappingURL=index.js.map